var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.25H4.5C4.10218 4.25 3.72064 4.40804 3.43934 4.68934C3.15804 4.97064 3 5.35218 3 5.75V14.75C3 15.1478 3.15804 15.5294 3.43934 15.8107C3.72064 16.092 4.10218 16.25 4.5 16.25H8.77275M13.5 11V14H16.5M13.5 8.75V5.75C13.5 5.35218 13.342 4.97064 13.0607 4.68934C12.7794 4.40804 12.3978 4.25 12 4.25H10.5",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.75H9M6 11.75H8.25M6 4.25C6 3.85218 6.15804 3.47064 6.43934 3.18934C6.72064 2.90804 7.10218 2.75 7.5 2.75H9C9.39783 2.75 9.77936 2.90804 10.0607 3.18934C10.342 3.47064 10.5 3.85218 10.5 4.25C10.5 4.64782 10.342 5.02936 10.0607 5.31066C9.77936 5.59196 9.39783 5.75 9 5.75H7.5C7.10218 5.75 6.72064 5.59196 6.43934 5.31066C6.15804 5.02936 6 4.64782 6 4.25ZM10.5 14C10.5 14.7956 10.8161 15.5587 11.3787 16.1213C11.9413 16.6839 12.7044 17 13.5 17C14.2957 17 15.0587 16.6839 15.6213 16.1213C16.1839 15.5587 16.5 14.7956 16.5 14C16.5 13.2044 16.1839 12.4413 15.6213 11.8787C15.0587 11.3161 14.2957 11 13.5 11C12.7044 11 11.9413 11.3161 11.3787 11.8787C10.8161 12.4413 10.5 13.2044 10.5 14Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.8550a3257f73b7ed8a0b482f6bf750f6.svg";
export { ForwardRef as ReactComponent };